<template>
<div class="chapter">
<div class="inner_page">
<div class="pubInfo font-AtmaSerif-MediumRoman-5_1-12">
<a id="p4">
<p class="running_first color-3C1C00"><span class="font-AvantGarde-Book-4_1-8">Text copyright © 2009 by </span><span class="font-GoudyHeavyfaceBT-Regular-3_1-8_5">Bob Sloan</span></p>
<p class="running_first color-3C1C00"><span class="font-AvantGarde-Book-4_1-8">Photographs copyright © 2009 by </span><span class="font-GoudyHeavyfaceBT-Regular-3_1-8_5">Antonis Achilleos </span><span class="font-AvantGarde-Book-4_1-8">All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</span></p>
<p class="running_txt_indent color-3C1C00 font-AvantGarde-Book-4_1-8"> <br/></p>
<p class="running_first color-3C1C00 font-AvantGarde-Book-4_1-8">ISBN 978-1-4521-3162-7<br/>Library of Congress Cataloging-in-Publication Data available under ISBN 978-0-8118-6698-9.</p>
<p class="running_txt_indent color-3C1C00 font-AvantGarde-Book-4_1-8"> <br/></p>
<p class="running_first color-3C1C00"><span class="font-AvantGarde-Book-4_1-8">Prop styling by </span><span class="font-GoudyHeavyfaceBT-Regular-3_1-8_5">Sara Slavin</span></p>
<p class="running_first color-3C1C00"><span class="font-AvantGarde-Book-4_1-8">Food styling by </span><span class="font-GoudyHeavyfaceBT-Regular-3_1-8_5">Randy Mon</span></p>
<p class="running_first color-3C1C00"><span class="font-AvantGarde-Book-4_1-8">Opener Illustrations by </span><span class="font-GoudyHeavyfaceBT-Regular-3_1-8_5">Laura Bagnato</span></p>
<p class="running_txt_indent color-3C1C00 font-GoudyHeavyfaceBT-Regular-3_1-8_5"> <br/></p>
<p class="running_first color-3C1C00"><span class="font-AvantGarde-Book-4_1-8">Designed by </span><span class="font-GoudyHeavyfaceBT-Regular-3_1-8_5">MacFadden &amp; Thorpe</span></p>
<p class="running_txt_indent color-3C1C00 font-GoudyHeavyfaceBT-Regular-3_1-8_5"> <br/></p>
<p class="running_first color-3C1C00 font-AvantGarde-Book-4_1-8">Chronicle Books LLC</p>
<p class="running_first color-3C1C00 font-AvantGarde-Book-4_1-8">680 Second Street</p>
<p class="running_first color-3C1C00 font-AvantGarde-Book-4_1-8">San Francisco, California 94107</p>
<p class="running_txt_indent color-3C1C00 font-AvantGarde-Book-4_1-8"> <br/></p>
</a><p class="running_first color-3C1C00 font-AvantGarde-Book-4_1-8"><a id="p4"></a><a href="http://www.chroniclebooks.com" target="_blank"><span class="url">www.chroniclebooks.com</span></a></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003copyright.vue?598ce326